import api from '@/services/api'
import store from '../index'

export default {
  state: {
    courseSelected: {
      id: 0,
      name: '',
      status: '',
    },
  },

  mutations: {
    SET_COURSE_SELECTED(state, payload) {
      state.courseSelected = {
        id: payload.id,
        name: payload.name,
        status: payload.status,
      }
    },
  },

  actions: {
    // Courses

    async saveCourse({ commit }, course) {
      try {
        const { clientId } = store.getters.user

        return await api.post(`/${clientId}/courses`, course)
      } catch (error) {
        throw error
      }
    },

    async getCourses({ commit }) {
      try {
        const { clientId } = store.getters.user

        const response = await api.get(`/${clientId}/courses`)

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async getCourse({ commit }, courseId) {
      try {
        const { clientId } = store.getters.user

        const response = await api.get(`/${clientId}/courses/${courseId}`)

        const data = response && response.data ? response.data : null

        commit('SET_COURSE_SELECTED', {
          id: data.id ? data.id : null,
          name: data.name ? data.name : null,
          status: data.status ? data.status : null,
        })

        return data
      } catch (error) {
        throw error
      }
    },

    async getCoursesUser({ commit }, userId) {
      try {
        const { clientId } = store.getters.user

        const response = await api.get(`/${clientId}/users/${userId}/courses`)

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async updateCourse({ commit }, course) {
      try {
        const { clientId } = store.getters.user

        return await api.put(`/${clientId}/courses/${course.id}`, course)
      } catch (error) {
        throw error
      }
    },

    async updateStatusCourse({ commit }, course) {
      try {
        const { clientId } = store.getters.user

        return await api.put(`/${clientId}/courses/${course.id}/status`, course)
      } catch (error) {
        throw error
      }
    },

    // Roles Course

    async getRolesCourse({ commit }, courseId) {
      try {
        const { clientId } = store.getters.user

        const response = await api.get(`/${clientId}/courses/${courseId}/roles`)

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    // Modules Course

    async saveModule({ commit }, data) {
      try {
        const { clientId } = store.getters.user

        return await api.post(
          `/${clientId}/courses/${data.courseId}/modules`,
          data.module,
        )
      } catch (error) {
        throw error
      }
    },

    async getModules({ commit }, courseId) {
      try {
        const { clientId } = store.getters.user

        const response = await api.get(
          `/${clientId}/courses/${courseId}/modules`,
        )

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async getModule({ commit }, data) {
      try {
        const { clientId } = store.getters.user

        const response = await api.get(
          `/${clientId}/courses/${data.courseId}/modules/${data.moduleId}`,
        )

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async updateModule({ commit }, data) {
      try {
        const { clientId } = store.getters.user

        return await api.put(
          `/${clientId}/courses/${data.courseId}/modules/${data.moduleId}`,
          data.module,
        )
      } catch (error) {
        throw error
      }
    },

    // Lessons Module

    async saveLesson({ commit }, data) {
      try {
        const { clientId } = store.getters.user

        return await api.post(
          `/${clientId}/courses/${data.courseId}/modules/${data.moduleId}/lessons`,
          data.lesson,
        )
      } catch (error) {
        throw error
      }
    },

    async getLessons({ commit }, data) {
      try {
        const { clientId } = store.getters.user

        const response = await api.get(
          `/${clientId}/courses/${data.courseId}/modules/${data.moduleId}/lessons`,
        )

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async getLesson({ commit }, data) {
      try {
        const { clientId } = store.getters.user

        const response = await api.get(
          `/${clientId}/courses/${data.courseId}/modules/${data.moduleId}/lessons/${data.lessonId}`,
        )

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async updateLesson({ commit }, data) {
      try {
        const { clientId } = store.getters.user

        return await api.put(
          `/${clientId}/courses/${data.courseId}/modules/${data.moduleId}/lessons/${data.lessonId}`,
          data.lesson,
        )
      } catch (error) {
        throw error
      }
    },

    // Questions Lesson/Course

    async saveQuestion({ commit }, data) {
      try {
        const { clientId } = store.getters.user

        let url = `/${clientId}/courses/${data.courseId}`

        if (data.typeQuestion === 'lesson') {
          url += `/modules/${data.moduleId}/lessons/${data.lessonId}/questions`
        } else {
          url += `/tests`
        }

        return await api.post(url, data.question)
      } catch (error) {
        throw error
      }
    },

    async getQuestions({ commit }, data) {
      try {
        const { clientId } = store.getters.user

        const response = await api.get(
          `/${clientId}/courses/${data.courseId}/tests`,
        )

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async getQuestion({ commit }, data) {
      try {
        const { clientId } = store.getters.user

        let url = `/${clientId}/courses/${data.courseId}`

        if (data.typeQuestion === 'lesson') {
          url += `/modules/${data.moduleId}/lessons/${data.lessonId}/questions`
        } else {
          url += `/tests`
        }

        url += `/${data.questionId}`

        const response = await api.get(url)

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async updateQuestion({ commit }, data) {
      try {
        const { clientId } = store.getters.user

        let url = `/${clientId}/courses/${data.courseId}`

        if (data.typeQuestion === 'lesson') {
          url += `/modules/${data.moduleId}/lessons/${data.lessonId}/questions`
        } else {
          url += `/tests`
        }

        url += `/${data.questionId}`

        return await api.put(url, data.question)
      } catch (error) {
        throw error
      }
    },

    // Attachments Lesson

    async saveAttachment({ commit }, data) {
      try {
        const { clientId } = store.getters.user

        return await api.post(
          `/${clientId}/courses/${data.courseId}/modules/${data.moduleId}/lessons/${data.lessonId}/attachments`,
          data.attachment,
        )
      } catch (error) {
        throw error
      }
    },

    async deleteAttachment({ commit }, data) {
      try {
        const { clientId } = store.getters.user

        return await api.delete(
          `/${clientId}/courses/${data.courseId}/modules/${data.moduleId}/lessons/${data.lessonId}/attachments/${data.attachmentId}`,
        )
      } catch (error) {
        throw error
      }
    },
  },

  getters: {
    courseSelected: (state) => state.courseSelected,
  },
}
